export const menuStyles = {
  '.MuiMenu-paper': {
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.15)',
    paddingInline: {
      xxl: '5px', xl: '5px', lg: '4px', md: '2px',
    },
    width: { xxl: '13rem', xl: '11rem' },
    border: '1px solid #efefef',
  },
};

export const menuItemStyles = {
  fontSize: {
    xxl: '0.9rem', xl: '0.7rem', lg: '0.6rem', md: '0.5rem',
  },
  '&:hover': {
    backgroundColor: '#e0f2ff',
  },
};
